/*
 * @Author: hcl
 * @Date: 2023-06-09 12:16:52
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-10-16 18:15:24
 * @FilePath: \fe-crm\src\store\modules\contacts.js
 * @Description: 获取联系人
 */
import { publicService } from '@/api/';
import { defineStore } from 'pinia';
// import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
import i18n from '@/locales/index';
export const useContactsStore = defineStore('getcontacts', {
  state: () => ({
    selectContacts: {
      data: [], //联系人数据
      contactsTree: [] //联系人树
    }
  }),
  actions: {
    // 获取联系人列表树
    getContactList(params) {
      this.selectContacts.data = [];
      return new Promise((resolve, reject) => {
        publicService
          .getContactList(params)
          .then((res) => {
            if (res.error) {
              Message.error(res.error?.msg || i18n.global.t('未找到联系人'));
              return;
            }
            if (res.result?.length == 0 && params.calling) {
              Message.error(i18n.global.t('未找到联系人'));
              return;
            }
            if (res.result?.length > 0) {
              this.selectContacts.data = res.result ?? [];
              // if (params.calling && res.result?.length === 1) {
              //   // //拨打电话
              //   this.callOut({
              //     id: params.businessId, //主键id
              //     type: params.type,
              //     callee: tools.clearCountryNum(res.result?.[0].mobile),
              //     calleeName: res.result?.[0].name,
              //     linkManId: res.result?.[0].id //联系人id
              //   });
              // }
            }

            resolve(res);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || i18n.global.t('获取数据失败'));
            reject(err);
          });
      });
    },
    // 通话接口
    callOut(params) {
      console.log(61, params);
      return new Promise((resolve, reject) => {
        publicService
          .callOut(params)
          .then((json) => {
            console.log('http res ========> ', json);
            if (!json.error) {
              Message.success(i18n.global.t('呼叫已拨出'));
            } else {
              if (json.error?.code === 10107) {
                Message.success(json.error?.msg || i18n.global.t('出错了'));
              } else {
                Message.error(json.error?.msg || i18n.global.t('操作失败'));
              }
            }
            resolve(json);
          })
          .catch((err) => {
            Message.error(err?.msg || i18n.global.t('操作失败'));
            reject(err);
          });
      });
    },
    //新增联系人
    async addContacts(params, cb) {
      try {
        const json = await publicService.getContactAdd(params);
        if (!json.error) {
          Message.success(i18n.global.t('操作成功'));
          cb && cb();
        } else {
          Message.error(json.error?.msg || i18n.global.t('操作失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || i18n.global.t('操作失败'));
      }
    },
    //编辑联系人
    async updateContacts(params, cb) {
      try {
        const json = await publicService.getContactUpdate(params);
        if (!json.error) {
          Message.success(i18n.global.t('操作成功'));
          cb && cb();
        } else {
          Message.error(json.error?.msg || i18n.global.t('操作失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || i18n.global.t('操作失败'));
      }
    },
    //设为默认联系人
    async setContactDefault(params, cb) {
      try {
        const json = await publicService.getContactDefault(params);
        if (!json.error) {
          Message.success(i18n.global.t('操作成功'));
          cb && cb();
        } else {
          Message.error(json.error?.msg || i18n.global.t('操作失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || i18n.global.t('操作失败'));
      }
    },
    //删除联系人
    async removeContact(params, cb) {
      try {
        const json = await publicService.deleteContact(params);
        if (!json.error) {
          Message.success(i18n.global.t('操作成功'));
          cb && cb();
        } else {
          Message.error(json.error?.msg || i18n.global.t('操作失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || i18n.global.t('操作失败'));
      }
    }
  }
});
export default useContactsStore;
